// Recovered compiled webpack factory 31209. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, {
    Cj: () => g,
    W3: () => l,
    bN: () => d,
    bm: () => h,
    h4: () => s,
    hP: () => c,
    n2: () => y,
    y5: () => p,
    yH: () => u,
    zk: () => m,
  });
  var n = r(60057),
    a = r(22758),
    o = r(2332),
    i = r(49636);
  function s(e, t = []) {
    return [e, t];
  }
  function l(e, t) {
    let [r, n] = e;
    return [r, [...n, t]];
  }
  function u(e, t) {
    for (let r of e[1]) {
      let e = r[0].type;
      if (t(r, e)) return !0;
    }
    return !1;
  }
  function c(e, t) {
    return u(e, (e, r) => t.includes(r));
  }
  function f(e) {
    let t = (0, n.Se)(i.O);
    return t.encodePolyfill ? t.encodePolyfill(e) : new TextEncoder().encode(e);
  }
  function d(e) {
    let [t, r] = e,
      n = JSON.stringify(t);
    function a(e) {
      "string" == typeof n
        ? (n = "string" == typeof e ? n + e : [f(n), e])
        : n.push("string" == typeof e ? f(e) : e);
    }
    for (let e of r) {
      let [t, r] = e;
      if (
        (a(`
${JSON.stringify(t)}
`),
        "string" == typeof r || r instanceof Uint8Array)
      )
        a(r);
      else {
        let e;
        try {
          e = JSON.stringify(r);
        } catch {
          e = JSON.stringify((0, o.S8)(r));
        }
        a(e);
      }
    }
    return "string" == typeof n
      ? n
      : (function (e) {
          let t = new Uint8Array(e.reduce((e, t) => e + t.length, 0)),
            r = 0;
          for (let n of e) (t.set(n, r), (r += n.length));
          return t;
        })(n);
  }
  function p(e) {
    return [{ type: "span" }, e];
  }
  function h(e) {
    let t = "string" == typeof e.data ? f(e.data) : e.data;
    return [
      {
        type: "attachment",
        length: t.length,
        filename: e.filename,
        content_type: e.contentType,
        attachment_type: e.attachmentType,
      },
      t,
    ];
  }
  let _ = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric",
  };
  function m(e) {
    return e in _ ? _[e] : e;
  }
  function g(e) {
    if (!e?.sdk) return;
    let { name: t, version: r } = e.sdk;
    return { name: t, version: r };
  }
  function y(e, t, r, n) {
    let o = e.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
      event_id: e.event_id,
      sent_at: new Date().toISOString(),
      ...(t && { sdk: t }),
      ...(!!r && n && { dsn: (0, a.SB)(n) }),
      ...(o && { trace: o }),
    };
  }
}
